module.exports = __webpack_public_path__ + "img/banner_03.4171d040.jpg";